module.exports = __webpack_public_path__ + "img/aj-claytonacres.a0d5dd88.jpg";